import {HttpClient, HttpHeaders} from '@angular/common/http';
import {inject, Service} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {PartNumberDecoder} from '../model/part-number-decoder';
import {GoogleService} from './google-service';

@Service()
export class PartNumberDecoderService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);

  private urlBase = environment.serviceUrl;

  public decode(partNumbers: string[], priceBasisDate: string): Observable<PartNumberDecoder[]> {
    const url = this.urlBase + 'partnumberdecoder?priceBasisDate=' + encodeURIComponent(priceBasisDate);
    return this.http.post<PartNumberDecoder[]>(url, JSON.stringify(partNumbers), {headers: this.getPostHeaders()});
  }

  public exportToExcel(decoderResults: PartNumberDecoder[]): Observable<Blob> {
    const url = this.urlBase + 'partnumberdecoder/excel';
    return this.http.post(url, JSON.stringify(decoderResults), {
      headers: this.getPostHeaders(),
      observe: 'response',
      responseType: 'blob'
    }).pipe(map((response: any) => new Blob([response.body], {type: response.headers.get('Content-Type')})));
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set('Content-Type', 'application/json');
  }
}
